"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Flex = _interopRequireDefault(require("../flex/Flex"));

var _Typography = _interopRequireDefault(require("../typography/Typography"));

var _useTheme = _interopRequireDefault(require("../useTheme"));

var _BackgroundColorContext = _interopRequireDefault(require("../BackgroundColorContext"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var BulletedListItem = function BulletedListItem(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, children);
};

var DxcBulletedList = function DxcBulletedList(_ref2) {
  var children = _ref2.children,
      _ref2$type = _ref2.type,
      type = _ref2$type === void 0 ? "disc" : _ref2$type,
      _ref2$icon = _ref2.icon,
      icon = _ref2$icon === void 0 ? "" : _ref2$icon;
  var colorsTheme = (0, _useTheme["default"])();
  var backgroundType = (0, _react.useContext)(_BackgroundColorContext["default"]);
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: colorsTheme.bulletedList
  }, /*#__PURE__*/_react["default"].createElement(ListContainer, null, /*#__PURE__*/_react["default"].createElement(_Flex["default"], {
    direction: "column",
    as: type === "number" ? "ol" : "ul",
    gap: "0.125rem"
  }, _react["default"].Children.map(children, function (child, index) {
    return /*#__PURE__*/_react["default"].createElement(ListItem, null, /*#__PURE__*/_react["default"].createElement(GeneralContent, null, type === "number" ? /*#__PURE__*/_react["default"].createElement(Number, null, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
      color: backgroundType && backgroundType === "dark" ? colorsTheme.bulletedList.fontColorOnDark : colorsTheme.bulletedList.fontColor
    }, index + 1, ".")) : type === "square" ? /*#__PURE__*/_react["default"].createElement(Bullet, null, /*#__PURE__*/_react["default"].createElement(Square, {
      backgroundType: backgroundType
    })) : type === "circle" ? /*#__PURE__*/_react["default"].createElement(Bullet, null, /*#__PURE__*/_react["default"].createElement(Circle, {
      backgroundType: backgroundType
    })) : type === "icon" ? /*#__PURE__*/_react["default"].createElement(Bullet, null, /*#__PURE__*/_react["default"].createElement(Icon, {
      backgroundType: backgroundType
    }, icon)) : /*#__PURE__*/_react["default"].createElement(Bullet, null, /*#__PURE__*/_react["default"].createElement(Disc, {
      backgroundType: backgroundType
    })), /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
      color: backgroundType && backgroundType === "dark" ? colorsTheme.bulletedList.fontColorOnDark : colorsTheme.bulletedList.fontColor
    }, child)));
  }))));
};

DxcBulletedList.Item = BulletedListItem;

var ListContainer = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  ul,\n  ol {\n    padding: 0;\n    margin: 0;\n  }\n"])));

var Bullet = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  align-self: flex-start;\n  align-items: center;\n  height: 1.5rem;\n"])));

var GeneralContent = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  display: grid;\n  grid-template-columns: auto 1fr;\n  align-items: center;\n"])));

var Icon = _styledComponents["default"].div(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  height: 1.5rem;\n  width: auto;\n  margin-right: ", ";\n  align-content: center;\n  color: ", ";\n  & > svg {\n    height: ", ";\n    width: ", ";\n  }\n"])), function (props) {
  return props.theme.bulletMarginRight;
}, function (props) {
  return props.backgroundType && props.backgroundType === "dark" ? props.theme.fontColorOnDark : props.theme.fontColor;
}, function (props) {
  return props.theme.bulletIconHeight;
}, function (props) {
  return props.theme.bulletIconWidth;
});

var Number = _styledComponents["default"].div(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n  user-select: none;\n  margin-right: ", ";\n  display: flex;\n  box-sizing: border-box;\n  align-self: flex-start;\n  min-width: 0;\n"])), function (props) {
  return props.theme.bulletMarginRight;
});

var Square = _styledComponents["default"].div(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n  background-color: ", ";\n  height: ", ";\n  width: ", ";\n  margin-right: ", ";\n"])), function (props) {
  return props.backgroundType && props.backgroundType === "dark" ? props.theme.fontColorOnDark : props.theme.fontColor;
}, function (props) {
  return props.theme.bulletHeight;
}, function (props) {
  return props.theme.bulletWidth;
}, function (props) {
  return props.theme.bulletMarginRight;
});

var Circle = _styledComponents["default"].div(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2["default"])(["\n  height: ", ";\n  width: ", ";\n  border-radius: 50%;\n  border: 1px solid;\n  border-color: ", ";\n  margin-right: ", ";\n"])), function (props) {
  return props.theme.bulletHeight;
}, function (props) {
  return props.theme.bulletWidth;
}, function (props) {
  return props.backgroundType && props.backgroundType === "dark" ? props.theme.fontColorOnDark : props.theme.fontColor;
}, function (props) {
  return props.theme.bulletMarginRight;
});

var Disc = _styledComponents["default"].div(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2["default"])(["\n  background-color: ", ";\n  height: ", ";\n  width: ", ";\n  border-radius: 50%;\n  margin-right: ", ";\n"])), function (props) {
  return props.backgroundType && props.backgroundType === "dark" ? props.theme.fontColorOnDark : props.theme.fontColor;
}, function (props) {
  return props.theme.bulletHeight;
}, function (props) {
  return props.theme.bulletWidth;
}, function (props) {
  return props.theme.bulletMarginRight;
});

var ListItem = _styledComponents["default"].li(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2["default"])(["\n  margin: 0px;\n  padding: 0px;\n  list-style: none;\n  display: flex;\n  font-size: 1em;\n"])));

var _default = DxcBulletedList;
exports["default"] = _default;